module.exports = __webpack_public_path__ + "img/mycards.08df34d7.svg";